﻿import { and, defaultTo, ifElse, isEmpty, isNil, length, match, join } from "ramda"
import { flow, pipe } from "fp-ts/es6/function"

import * as Logic from "../logic/index.js"
import * as Str from "../str/index.js"
import { params } from "./_params.js"

export { params }

const blockElements = [
  "br",
  "address",
  "article",
  "aside",
  "blockquote",
  "canvas",
  "dd",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "hr",
  "li",
  "main",
  "nav",
  "noscript",
  "ol",
  "p",
  "pre",
  "section",
  "table",
  "tbody",
  "td",
  "tr",
  "tfoot",
  "ul",
  "video",
]

const toPlainText = (html) => {
  const node = document.createElement("div")

  node.innerHTML = html

  return and(isEmpty(node.textContent), isNil(node.innerText))
    ? ""
    : node.textContent || node.innerText
}

export const wordCount = flow(
  Str.withReplaced(
    [new RegExp(`</?(${join("|", blockElements)})((([^>]+)>)|>)`, "gi"), " "],
    [/(\r\n|\n|\r)/gm, " "],
    [/^\s+|\s+$/g, ""],
    ["&nbsp;", " "],
  ),

  toPlainText,
  match(params.wordsDetect.regexpObject),
  ifElse(Logic.isNonEmpty, length, defaultTo(0)),
)

export const charCount = (text, { countSpacesAsChars } = { countSpacesAsChars: true }) =>
  pipe(
    text,

    Str.withReplaced(
      countSpacesAsChars
        ? ([/(\r\n|\n|\r)/gm, " "], [/^\s+|\s+$/g, ""], ["&nbsp;", " "])
        : ([/\s/g, ""], [/&nbsp;/g, ""]),
    ),

    toPlainText,
    length,
  )
